var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"container"},[_c('iframe',{staticClass:"frame",attrs:{"src":_vm.data.data.path,"width":"100%","height":"100%"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }